import { render, staticRenderFns } from "./AspirantesConvertidosPoliciaTabContent.vue?vue&type=template&id=57b8512e"
import script from "./AspirantesConvertidosPoliciaTabContent.vue?vue&type=script&lang=js"
export * from "./AspirantesConvertidosPoliciaTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports